/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{color:#646464;text-align:left}form[_ngcontent-%COMP%]{display:grid;grid-auto-flow:column;grid-template-columns:80px 1fr;grid-gap:1rem}label[_ngcontent-%COMP%]{position:relative}cc-input-errors[_ngcontent-%COMP%]{display:block}cc-input-errors[_ngcontent-%COMP%]     div{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}"];
export { styles as styles };
